enum ProjectSelectboxActionTypesEnum {
    LOAD_SUCCESS = "PORTAL_LOAD_PROJECT_SELECTBOX_success",
    LOAD_ERROR = "PORTAL_LOAD_PROJECT_SELECTBOX_error",
}

export default ProjectSelectboxActionTypesEnum;
